"use strict";

define('rs/models/product',['rs/models/abstract'], function (Abstract) {
  var ALL_PRODUCTS = null;
  var Product = Abstract.extend({}, {
    rootUrl: '/rs/api/tenant/',
    parsers: {
      'product': 'models'
    },
    findByName: function findByName(name) {
      var _name = String(name || '').toLowerCase();
      return this.findAll().then(function (products) {
        return _.find(products, function (product) {
          return String(product.name).toLowerCase() == _name;
        });
      });
    },
    findAll: function findAll() {
      if (ALL_PRODUCTS) {
        return Promise.resolve(ALL_PRODUCTS);
      }
      return this.get('product').tap(function (products) {
        ALL_PRODUCTS = products;
      });
    }
  });
  return Product;
});

